import { createSelector } from 'reselect'

import { RequestStatus } from 'clickNgo/configs/service/common'

import { selectLandingState } from './selectLandingState'

export const selectLandingIsPlanInitLoading = createSelector(
  [selectLandingState],
  ({ fetchPlanInitStatus }) => fetchPlanInitStatus === RequestStatus.PENDING
)
